import { render, staticRenderFns } from "./indexdemo.vue?vue&type=template&id=25969848&"
import script from "./indexdemo.vue?vue&type=script&lang=js&"
export * from "./indexdemo.vue?vue&type=script&lang=js&"
import style0 from "./indexdemo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25969848')) {
      api.createRecord('25969848', component.options)
    } else {
      api.reload('25969848', component.options)
    }
    module.hot.accept("./indexdemo.vue?vue&type=template&id=25969848&", function () {
      api.rerender('25969848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/renwu/indexdemo.vue"
export default component.exports